import { render, staticRenderFns } from "./land-nav.vue?vue&type=template&id=d95dcc52&"
import script from "./land-nav.vue?vue&type=script&lang=js&"
export * from "./land-nav.vue?vue&type=script&lang=js&"
import style0 from "./land-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports